"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.isPrimitiveType = isPrimitiveType;function isPrimitiveType(value) {
  return Object(value) !== value;
}
//# sourceMappingURL=common.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../lib/common.js
 ** module id = 435
 ** module chunks = 0
 **/